// extracted by mini-css-extract-plugin
export default {"switches":"styles_switches__O+RNn","switch":"styles_switch__Q5qFC","select":"styles_select__syXQi"};